import React from 'react';
import { Sparkle } from '@phosphor-icons/react';
import { Button } from '../../../components';
import { format } from 'date-fns';
import './style'
import { convertCustomDateFormatToISO } from '../../../utils/commonUtils';

const Ticket = (props) => {
  const {
    event,
    isSold,
    tickets,
    ticketCategory,
    ticketPrice,
    onMarkSoldClick,
    onEditClick,
    updatedAt,
    isEventLive,
  } = props;

  const formattedTime = event?.payload?.start_date ? format(convertCustomDateFormatToISO(event?.payload?.start_date), 'EEE, dd MMM yyyy, h:mm a') : null;
  const formattedSoldDate = isSold ? format(new Date(updatedAt), 'dd MMM yyyy') : null;


  return (
    <div className='flex flex-col gap-5 rounded-lg border-grey-10 border p-5  w-full md:w-[560px] md:max-w-[600px]'>
      <div className='flex md:flex-row gap-5 flex-col'>
        <img src={event?.payload?.image} 
          alt={event?.payload?.name} 
          className='w-[100%] h-[164px] md:w-[126px] md:h-[72px] object-cover rounded-lg' />
        <div className='flex flex-col gap-1'>
          <div className='heading-16'>{event?.payload?.name}</div>
          <div className='text-16 text-grey-70'>{formattedTime}</div>
          <div className='text-16 text-grey-70'>{event?.payload?.venue}</div>
        </div>
      </div>

      <div className='flex justify-between'>
        <div className='flex flex-col'>
          <div className='heading-16'>{tickets} {tickets === 1 ? 'ticket' : 'tickets'}</div>
          <div className='text-14'>{ticketCategory}</div>
        </div>
        <div className='flex flex-col text-right'>
          <div className='heading-16 text-primary-green'>₹{Math.round(ticketPrice)}</div>
          <div>per ticket</div>
        </div>
      </div>

      {isSold ? (
        <div className='bg-light-green rounded-xl items-center flex gap-2 px-6 py-4 justify-center'>
          <Sparkle size='24' 
            weight='fill' 
            color='#009D64' /> Sold on {formattedSoldDate} ✌️
        </div>
      ) : (
        <div className='flex md:justify-between w-full'>
          {isEventLive ? (
            <div className='flex gap-5 md:flex-row flex-col-reverse w-full '>
              <Button
                type='secondary md:w-[250px] w-full'
                className='flex items-center'
                onClick={onEditClick}
              >
                Edit listing
              </Button>
              <Button
                type='primary-black md:w-[250px] w-full'
                onClick={onMarkSoldClick}
              >
                Mark as sold
              </Button>
            </div>
          ) : (
            <Button
              type='primary-black'
              onClick={onMarkSoldClick}
              className='w-full'
            >
              Mark as sold
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default Ticket;
